(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["JBA"] = factory();
	else
		root["JBA"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
class Stack {
    constructor(maxStackCount = 20) {
        this.maxStackCount = maxStackCount;
        this.stack = [];
    }
    push(value) {
        if (this.length() >= this.maxStackCount) {
            this.stack.shift();
        }
        this.stack.push(value);
    }
    pop() {
        return this.stack.pop();
    }
    peek() {
        if (this.length() === 0) {
            return null;
        }
        return this.stack[this.stack.length - 1];
    }
    length() {
        return this.stack.length;
    }
    ;
}
/* harmony export (immutable) */ __webpack_exports__["a"] = Stack;

class BBoxUtils {
    static toBBoxPositionFromStyle(ele, size) {
        var start = { x: parseInt(ele.style.left), y: parseInt(ele.style.top) };
        var end = {
            x: parseInt(ele.style.left) + parseInt(ele.style.width),
            y: parseInt(ele.style.top) + parseInt(ele.style.height)
        };
        return BBoxUtils.toBBoxPosition(size, start, end);
    }
    static setStyleFromBBoxPosition(ele, size, p) {
        var _toStr = (x) => x + 'px';
        ele.style.top = _toStr(p.y1 * size.height);
        ele.style.left = _toStr(p.x1 * size.width);
        ele.style.width = _toStr((p.x2 - p.x1) * size.width);
        ele.style.height = _toStr((p.y2 - p.y1) * size.height);
        return ele;
    }
    static getPosition(pageX, pageY, frameOffset) {
        var scrollX = window.scrollX;
        var scrollY = window.scrollY;
        return {
            x: Math.min(Math.max(Math.round(pageX - scrollX - frameOffset.left), 0), Math.round(frameOffset.width)),
            y: Math.min(Math.max(Math.round(pageY - scrollY - frameOffset.top), 0), Math.round(frameOffset.height))
        };
    }
    ;
    static toBBoxPosition(size, start, end) {
        var x1, x2, y1, y2;
        x1 = Math.min(start.x, end.x) / size.width;
        y1 = Math.min(start.y, end.y) / size.height;
        x2 = Math.max(start.x, end.x) / size.width;
        y2 = Math.max(start.y, end.y) / size.height;
        return {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
        };
    }
}
/* harmony export (immutable) */ __webpack_exports__["b"] = BBoxUtils;



/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handler__ = __webpack_require__(3);


class BBoxAnnotator {
    constructor(frame, onChangeCb, options) {
        this.frame = frame;
        this.onChangeCb = onChangeCb;
        this.options = options;
        this.isHolding = false;
        // {'bbox-[0-9]+': BBox}
        this.bboxes = {};
        this.bboxIndex = 0;
        this.undoStack = new __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* Stack */]();
        // initilize frame setting
        this.frame.style.cursor = 'crosshair';
        this.selector = this._createBBoxSelector();
        this.selector.style.display = 'none';
        this.frame.appendChild(this.selector);
        // initilize event lintener
        this.frame.addEventListener('mousedown', this.onStart.bind(this));
        this.frame.addEventListener('mousemove', this.onMoving.bind(this));
        this.frame.addEventListener('mouseup', this.onEnd.bind(this));
    }
    onStart(e) {
        if (this.isHolding)
            return false;
        this.isHolding = true;
        this.startPosition = __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* BBoxUtils */].getPosition(e.pageX, e.pageY, this.frame.getBoundingClientRect());
        this.endPosition = this.startPosition;
        this.rerender();
        return document.onselectstart = function () {
            return false;
        };
    }
    onMoving(e) {
        if (this.isHolding) {
            this.endPosition = __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* BBoxUtils */].getPosition(e.pageX, e.pageY, this.frame.getBoundingClientRect());
            this.rerender();
        }
        return true;
    }
    onEnd(e) {
        if (this.isHolding) {
            this.endPosition = __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* BBoxUtils */].getPosition(e.pageX, e.pageY, this.frame.getBoundingClientRect());
            var p = __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* BBoxUtils */].toBBoxPosition({ width: this.frame.clientWidth, height: this.frame.clientHeight }, this.startPosition, this.endPosition);
            var bbox = new BBox(p.x1, p.y1, p.x2, p.y2);
            this.isHolding = false;
            this.selector.style.display = 'none';
            this.startPosition = null;
            this.endPosition = null;
            this.addBBox(bbox);
        }
        return true;
    }
    onChange(event, bbox) {
        if (this.onChangeCb)
            this.onChangeCb(event, bbox);
    }
    doHighlight(bboxKey) {
        var prevHighlight = this.frame.querySelector(`.highlight-bbox`);
        if (prevHighlight) {
            prevHighlight.classList.remove('highlight-bbox');
        }
        if (!bboxKey) {
            this.refreshCaptionVisibility();
            return;
        }
        var bboxEle = this.frame.querySelector(`.${bboxKey}`);
        if (!bboxEle) {
            throw new Error(`Not exists element. bboxKey:${bboxKey}`);
        }
        this.frame.appendChild(bboxEle);
        bboxEle.classList.add('highlight-bbox');
        this.refreshCaptionVisibility(bboxEle);
    }
    refreshCaptionVisibility(activeBBoxEle = null) {
        var bboxElements = Array.from(this.frame.querySelectorAll(`.bbox-annotated`));
        bboxElements.forEach((bboxEle) => {
            bboxEle.classList.remove('hidden-caption');
        });
        if (activeBBoxEle) {
            var activeRect = activeBBoxEle.getBoundingClientRect();
            bboxElements.forEach((bboxEle) => {
                if (bboxEle !== activeBBoxEle && this.isOverlapping(bboxEle.getBoundingClientRect(), activeRect)) {
                    bboxEle.classList.add('hidden-caption');
                }
            });
        }
        var frontRects = [];
        for (var index = bboxElements.length - 1; index >= 0; index--) {
            var bboxEle = bboxElements[index];
            if (bboxEle.classList.contains('hidden-caption')) {
                continue;
            }
            var rect = bboxEle.getBoundingClientRect();
            var isCovered = frontRects.some((frontRect) => this.isOverlapping(rect, frontRect));
            if (isCovered) {
                bboxEle.classList.add('hidden-caption');
                continue;
            }
            frontRects.push(rect);
        }
    }
    isOverlapping(rect1, rect2) {
        return rect1.left < rect2.right && rect2.left < rect1.right && rect1.top < rect2.bottom && rect2.top < rect1.bottom;
    }
    setMetaBBox(bboxKey, meta) {
        var bbox = this.bboxes[bboxKey];
        if (!bbox) {
            throw new Error(`${bboxKey} is undefined.`);
        }
        bbox.meta = meta;
        if (this.options.labelView) {
            this.removeBBox(bbox.id, true);
            this.addBBox(bbox, true);
        }
    }
    addBBox(bbox, isSilent = false) {
        this.bboxes[bbox.id] = bbox;
        var bboxEle = this.toElementFromBBox(bbox);
        bboxEle.classList.add(bbox.id);
        this.frame.appendChild(bboxEle);
        this.refreshCaptionVisibility();
        if (!isSilent) {
            this.undoStack.push(new __WEBPACK_IMPORTED_MODULE_1__handler__["a" /* AddCommandHistory */](this.frame, bbox.id, {
                start: null,
                end: bbox
            }, {
                onUndo: (self) => {
                    delete this.bboxes[self.bboxId];
                }
            }));
            // fire event.
            this.onChange('add', bbox);
        }
    }
    removeBBox(bboxId, isSilent = false) {
        var _bbox = this.bboxes[bboxId];
        delete this.bboxes[bboxId];
        var bboxEle = document.querySelector(`.${bboxId}`);
        bboxEle.parentNode.removeChild(bboxEle);
        this.refreshCaptionVisibility();
        if (!isSilent) {
            this.undoStack.push({
                bboxId: bboxId,
                undo: () => {
                    this.bboxes[_bbox.id] = _bbox;
                    var bboxEle = this.toElementFromBBox(_bbox);
                    bboxEle.classList.add(_bbox.id);
                    this.frame.appendChild(bboxEle);
                    this.refreshCaptionVisibility();
                },
                redo: () => { }
            });
            // fire event.
            this.onChange('remove', _bbox);
        }
    }
    importBBox(p) {
        var bbox = new BBox(p.x1, p.y1, p.x2, p.y2);
        bbox.meta = p.meta;
        this.addBBox(bbox);
    }
    undo() {
        if (this.undoStack.length() === 0) {
            return;
        }
        var target = this.undoStack.pop();
        target.undo();
        this.refreshCaptionVisibility();
        this.onChangeCb('change', this.bboxes[target.bboxId]);
    }
    reset() {
        while (this.frame.firstChild)
            this.frame.removeChild(this.frame.firstChild);
        this.bboxes = [];
        this.frame.appendChild(this.selector);
        this.refreshCaptionVisibility();
        // fire event.
        this.onChange('reset', null);
    }
    rerender() {
        var bbox = __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* BBoxUtils */].toBBoxPosition({ width: this.frame.clientWidth, height: this.frame.clientHeight }, this.startPosition, this.endPosition);
        this.selector = __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* BBoxUtils */].setStyleFromBBoxPosition(this.selector, { width: this.frame.clientWidth, height: this.frame.clientHeight }, bbox);
        this.selector.style.display = 'block';
    }
    ;
    onBBoxRemove(e) {
        var bbox = e.srcElement.parentElement;
        while (bbox.firstChild)
            bbox.removeChild(bbox.firstChild);
        // delete from bboxes
        var bboxKey = bbox.className.match(/bbox-([0-9]+)/)[0];
        e.stopImmediatePropagation();
        e.preventDefault();
        this.removeBBox(bboxKey);
    }
    exportBBox() {
        return Object.keys(this.bboxes).map((key) => this.bboxes[key]).concat();
    }
    toElementFromBBox(bbox) {
        var div = document.createElement('div');
        div.classList.add('bbox-annotated');
        if (this.options.labelView) {
            div.appendChild(this.options.labelView(bbox.meta));
        }
        var handlerOptions = {
            onEnd: this.onBBoxChangeFinish.bind(this)
        };
        var resizer = document.createElement('div');
        resizer.classList.add('bbox-resizer');
        var bboxResizer = new __WEBPACK_IMPORTED_MODULE_1__handler__["b" /* BBoxResizer */](div, resizer, { width: this.frame.clientWidth, height: this.frame.clientHeight }, handlerOptions);
        div.appendChild(resizer);
        var mover = document.createElement('span');
        mover.classList.add('glyphicon', 'glyphicon-move', 'bbox-mover');
        var bboxMover = new __WEBPACK_IMPORTED_MODULE_1__handler__["c" /* BBoxMover */](div, mover, { width: this.frame.clientWidth, height: this.frame.clientHeight }, handlerOptions);
        div.appendChild(mover);
        div = __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* BBoxUtils */].setStyleFromBBoxPosition(div, { width: this.frame.clientWidth, height: this.frame.clientHeight }, bbox);
        var removeBtn = document.createElement('span');
        removeBtn.classList.add('glyphicon', 'glyphicon-remove', 'bbox-remover');
        removeBtn.addEventListener('mousedown', this.onBBoxRemove.bind(this));
        div.appendChild(removeBtn);
        return div;
    }
    onBBoxChangeFinish(ele, start, end) {
        var p = __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* BBoxUtils */].toBBoxPositionFromStyle(ele, { width: this.frame.clientWidth, height: this.frame.clientHeight });
        var bboxId = ele.className.match(/bbox-([0-9]+)/)[0];
        var bbox = this.bboxes[bboxId];
        bbox.x1 = p.x1;
        bbox.y1 = p.y1;
        bbox.x2 = p.x2;
        bbox.y2 = p.y2;
        start.meta = bbox.meta;
        end.meta = bbox.meta;
        this.undoStack.push(new __WEBPACK_IMPORTED_MODULE_1__handler__["d" /* DefaultCommandHistory */](this.frame, { width: this.frame.clientWidth, height: this.frame.clientHeight }, bboxId, {
            start: start,
            end: end
        }, {
            onUndo: (self, p) => {
                var bbox = this.bboxes[self.bboxId];
                bbox.x1 = p.x1;
                bbox.y1 = p.y1;
                bbox.x2 = p.x2;
                bbox.y2 = p.y2;
            }
        }));
        this.onChangeCb('change', bbox);
    }
    _createBBoxSelector() {
        var selector = document.createElement('div');
        selector.classList.add('bbox-selector');
        selector.style.position = 'relative';
        selector.style.border = '2px dotted rgb(127,255,127)';
        return selector;
    }
}
/* harmony export (immutable) */ __webpack_exports__["BBoxAnnotator"] = BBoxAnnotator;

class BBox {
    constructor(x1, y1, x2, y2) {
        this.x1 = x1;
        this.y1 = y1;
        this.x2 = x2;
        this.y2 = y2;
        this.meta = {};
        this.id = 'bbox-' + Date.now() + '' + BBox.BBOX_INDEX++;
    }
}
/* harmony export (immutable) */ __webpack_exports__["BBox"] = BBox;

BBox.BBOX_INDEX = 0;


/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);

class BBoxHandler {
    constructor(bbox, src, maxSize, options) {
        this.bbox = bbox;
        this.src = src;
        this.maxSize = maxSize;
        this.options = options;
        this._start = null;
        this._end = null;
    }
    _onStart() {
        this._start = __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* BBoxUtils */].toBBoxPositionFromStyle(this.bbox, this.maxSize);
        if (this.options.onStart) {
            this.options.onStart(this.bbox);
        }
    }
    _onEnd() {
        this._end = __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* BBoxUtils */].toBBoxPositionFromStyle(this.bbox, this.maxSize);
        if (this.options.onEnd) {
            this.options.onEnd(this.bbox, this._start, this._end);
        }
    }
    clip(val, min, max) {
        if (val <= min) {
            return min;
        }
        else if (val >= max) {
            return max;
        }
        else {
            return val;
        }
    }
}
/* unused harmony export BBoxHandler */

class BBoxResizer extends BBoxHandler {
    constructor(element, src, maxSize, options) {
        super(element, src, maxSize, options);
        this.src.addEventListener('mousedown', this.onStart.bind(this), false);
    }
    onStart(e) {
        e.stopImmediatePropagation();
        this.onResizingRef = this.onResizing.bind(this);
        this.onStopRef = this.onStop.bind(this);
        window.addEventListener('mousemove', this.onResizingRef, false);
        window.addEventListener('mouseup', this.onStopRef, false);
        this._onStart();
    }
    onResizing(e) {
        var frame = this.bbox.parentElement;
        var frameOffset = frame.getBoundingClientRect();
        var p = __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* BBoxUtils */].getPosition(e.pageX, e.pageY, frameOffset);
        this.bbox.style.width = p.x - parseInt(this.bbox.style.left) + 'px';
        this.bbox.style.height = p.y - parseInt(this.bbox.style.top) + 'px';
    }
    onStop(e) {
        e.stopImmediatePropagation();
        window.removeEventListener('mousemove', this.onResizingRef, false);
        window.removeEventListener('mouseup', this.onStopRef, false);
        this._onEnd();
        return true;
    }
}
/* harmony export (immutable) */ __webpack_exports__["b"] = BBoxResizer;

class BBoxMover extends BBoxHandler {
    constructor(element, src, maxSize, options) {
        super(element, src, maxSize, options);
        this.isHolding = false;
        src.addEventListener('mousedown', this.onStart.bind(this), false);
    }
    onStart(e) {
        e.stopImmediatePropagation();
        this.onMovingRef = this.onMoving.bind(this);
        this.onStopRef = this.onStop.bind(this);
        window.addEventListener('mousemove', this.onMovingRef, false);
        window.addEventListener('mouseup', this.onStopRef, false);
        this.isHolding = true;
        this._onStart();
    }
    onMoving(e) {
        e.stopImmediatePropagation();
        if (!this.isHolding) {
            return false;
        }
        var frame = this.bbox.parentElement;
        var frameOffset = frame.getBoundingClientRect();
        var p = __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* BBoxUtils */].getPosition(e.pageX, e.pageY, frameOffset);
        var styleHeight = parseInt(this.bbox.style.height);
        var maxTop = (this.maxSize.height - styleHeight);
        this.bbox.style.top = this.clip((p.y - (styleHeight / 2)), 0, maxTop) + 'px';
        var styleWidth = parseInt(this.bbox.style.width);
        var maxLeft = (this.maxSize.width - styleWidth);
        this.bbox.style.left = this.clip((p.x - (styleWidth / 2)), 0, maxLeft) + 'px';
    }
    onStop(e) {
        e.stopImmediatePropagation();
        window.removeEventListener('mousemove', this.onMovingRef, false);
        window.removeEventListener('mouseup', this.onStopRef, false);
        this.isHolding = false;
        this._onEnd();
        return true;
    }
}
/* harmony export (immutable) */ __webpack_exports__["c"] = BBoxMover;

class DefaultCommandHistory {
    constructor(frame, size, bboxId, position, options) {
        this.frame = frame;
        this.size = size;
        this.bboxId = bboxId;
        this.position = position;
        this.options = options;
    }
    undo() {
        var bboxEle = this.frame.querySelector(`.${this.bboxId}`);
        __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* BBoxUtils */].setStyleFromBBoxPosition(bboxEle, this.size, this.position.start);
        if (this.options.onUndo) {
            this.options.onUndo(this, this.position.start);
        }
    }
    redo() {
    }
}
/* harmony export (immutable) */ __webpack_exports__["d"] = DefaultCommandHistory;

class AddCommandHistory {
    constructor(frame, bboxId, position, options) {
        this.frame = frame;
        this.bboxId = bboxId;
        this.position = position;
        this.options = options;
    }
    undo() {
        var bboxEle = this.frame.querySelector(`.${this.bboxId}`);
        this.frame.removeChild(bboxEle);
        if (this.options.onUndo) {
            this.options.onUndo(this, null);
        }
    }
    redo() {
    }
}
/* harmony export (immutable) */ __webpack_exports__["a"] = AddCommandHistory;



/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ })
/******/ ]);
});
//# sourceMappingURL=jba.js.map